import jsonp from './jsonp.js'
import $ from 'jquery'
import md5 from 'js-md5';

export function getAllCity() {
  return new Promise(function (resolve, reject) {
    jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
      method: 'Area/GetCity'
    }).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getNav(cityId) {
  return new Promise(function (resolve, reject) {
    jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
      method: 'NavCategory/GetNavCategoryByCity',
      param: JSON.stringify({
        cityId
      }),
      callback: 'callback'
    }, {
      timeout: 5000
    }).then(
      response => {
        resolve(response)
      },
      err => {
        reject(err)
      }
    )
  })
}

export function getTeacherInfo(schoolId, courseCodes) {
  return new Promise(function (resolve, reject) {
    jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
      method: 'Teacher/GetTeacherByCourseCodes',
      param: JSON.stringify({
        schoolId,
        courseCodes
      }),
      callback: 'callback'
    }).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getMiddleTeacher(schoolId, pageSize) {
  return new Promise(function (resolve, reject) {
    jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
      method: 'Teacher/GetTeacherBySchoolSearch',
      param: JSON.stringify({
        schoolId,
        pageIndex: 1,
        pageSize,
        categoryCode: 20
      }),
      callback: 'callback'
    }).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getTopRegClass(cityId, categoryCode, size) {
  return new Promise(function (resolve, reject) {
    jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
      method: 'ClassRecommend/GetTopRegClassByCityCategory',
      param: JSON.stringify({
        cityId,
        categoryCode,
        size
      }),
      callback: 'callback'
    }).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getPhoneNumber(cityId) {
  return new Promise(function (resolve, reject) {
    jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
      method: 'School/GetSchoolConfigByCityId',
      param: JSON.stringify({
        cityId
      })
    }).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getHotKeyWord(cityId) {
  return new Promise(function (resolve, reject) {
    jsonp('http://cmsdt.xdf.cn/get_souke.php', {
      method: 'HotKeyWord.GetHotKeyWordByCity',
      param: JSON.stringify({
        cityId
      }),
      callback: 'HWL.data'
    }).then(response => {
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getSearchTips(cityId, keyword) {
  return new Promise((resolve, reject) => {
    $.get({
      url: `http://apisuggest.staff.xdf.cn/suggest/get?cityId=${cityId}&keyword=${keyword}`,
      success: function (res) {
        resolve(res)
      },
      error: function (err) {
        reject(err)
      }
    })
  })
}

export function getOnlineconsultingList(cityId, schoolId) {
  let t = new Date().getTime();
  let params = `appId=1003&cityId=${cityId}&t=${t}`;
  if (schoolId) {
    url = `${url}&schoolId=${schoolId}`
  }
  let sign = md5(`${params}v5appkey_sk_ivsw$xaz`);
  let url = `http://dsapi.xdf.cn/portal/v1/onlineconsulting/list?${params}`
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: url,
      headers: {
        sign
      },
      success: data => {
        resolve(data)
      },
      error: err => {
        console.log(err)
      },
    });
  });
}

function getCurrentDate() {
  var nowDate = new Date();
  nowDate=nowDate.setDate(nowDate.getDate()+1);
  nowDate=new Date(nowDate);
  var year = nowDate.getFullYear();
  var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
  var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
  var dateStr = year + month + day;
  return dateStr
}

export function getCourseBySearch(cityId, categoryCode, attr, pageSize) {
  return new Promise(function (resolve, reject) {
    jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
      method: 'Course/GetCourseBySearch',
      param: JSON.stringify({
        cityId,
        categoryCode,
        attr,
        pageIndex: 1,
        pageSize,
        applyState: 1,
        hide: 1,
        order: 3,
        isFilter: false,
        date : getCurrentDate(),
      }),
      callback: 'callback'
    }, {
      timeout: 5000
    }).then(response => {
      try {
        response = JSON.parse(removeTagInStr(JSON.stringify(response)))
      } catch (error) {
        console.log('过滤富媒体报错')
        response = response;
      }
      resolve(response)
    }, err => {
      reject(err)
    })
  })
}

export function getClassBySearch(cityId, pageSize, categoryCode, attr) {
  return new Promise(function (resolve, reject) {
    jsonp('http://deploy.xdf.cn/api/Soukeapi/souke', {
      method: 'Class/GetClassBySearch',
      param: JSON.stringify({
        cityId,
        pageIndex: 1,
        pageSize,
        applyState: 1,
        hide: 1,
        order: 3,
        categoryCode,
        attr,
        isFilter: false,
        date : getCurrentDate(),
      }),
      callback: 'callback'
    }, {
      timeout: 5000
    }).then(
      response => {
        resolve(response)
      },
      err => {
        reject(err)
      }
    )
  })
}


export function removeTagInStr(htmlStr) {
  var str = ''
  if (typeof htmlStr == 'string') {
    str = htmlStr.replace(/<[^<]+>/gi, '')
  }
  return str
}



// WEBPACK FOOTER //
// ./src/api/js/getSoukeData.js